<template>
  <div>
    <el-dialog :visible.sync="dialogVisible" width="300px" height="500px">
      <el-button size="mini" type="primary" @click="handleConfirm">确定</el-button>
      <el-tree :data="dataTree" :props="defaultProps" node-key="sysDepartment" @node-click="handleNodeClick" :expand-on-click-node="false"
        :default-expanded-keys="expandedKeys">
      </el-tree>
    </el-dialog>
  </div>
</template>

<script>
  import axios from '@/axios';

  export default {
    data() {
      return {
        dataTree: [],
        defaultProps: {
          children: 'children',
          label: function(data, node) {
            return data.sysDepartment.deptName;
          },
        },
        dialogVisible: false,
        data: {},
        node: {},
        expandedKeys: []
      };
    },
    methods: {
      getDataTree() {
        var url = 'framework/SysDepartment/queryDeptTree.do'
        var param = {}
        axios.get(url, param).then(response => {
          this.dataTree = response.data.data
          console.log(this.dataTree.length)
          if (this.dataTree.length == 1) {
            for (var node of this.dataTree) { 
              this.expandedKeys.push(node.sysDepartment)
            }
          } 
        });

      },
      handleNodeClick(data) {
        console.log(JSON.stringify(data))
        this.node = data.sysDepartment

      },
      show() {
        this.getDataTree()
        this.dialogVisible = true
      },
      handleConfirm() {
        //console.log(JSON.stringify(this.node))
        this.$emit('receviceFromChild', this.node);
        this.dialogVisible = false
      },
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/system/PopupDeptTree.vue